import { isSafeAssetUrl } from './assetUrl';

export type MerchantResultStatus = 'completed' | 'failed' | 'expired' | 'cancelled';

export function merchantResultStatus(status: string): MerchantResultStatus | null {
  if (status === 'completed') return 'completed';
  if (status === 'rejected' || status === 'failed') return 'failed';
  if (status === 'expired') return 'expired';
  if (status === 'cancelled') return 'cancelled';
  return null;
}

export function buildMerchantReturnUrl(
  rawUrl: string | null,
  publicId: string,
  status: string,
): string | null {
  if (!isSafeAssetUrl(rawUrl)) return null;
  const result = merchantResultStatus(status);
  if (result === null) return null;

  const url = new URL(rawUrl);
  url.searchParams.set('publicId', publicId);
  url.searchParams.set('status', result);
  return url.toString();
}
